"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderExportSelector = renderExportSelector;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _Checkbox = _interopRequireDefault(require("@eig-builder/core-ui/Checkbox"));

var _InputLabel = _interopRequireDefault(require("@eig-builder/core-ui/InputLabel"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var columnClick = function columnClick(item, headersClone, setHeadersClone) {
  var modHeadersClone = headersClone && headersClone.map(function (headerItem) {
    var cloneHeaderItem = _objectSpread({}, headerItem);

    if (item.name === cloneHeaderItem.name) {
      cloneHeaderItem.hideColumn = !cloneHeaderItem.hideColumn;
    }

    return cloneHeaderItem;
  });
  modHeadersClone && setHeadersClone(modHeadersClone);
};

function renderExportSelector(headersClone, setHeadersClone, tag) {
  var columns = headersClone && headersClone.map(function (item, index) {
    if (item.title) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: index,
        className: item.isRequired ? 'disabled' : ''
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "column-selector-container",
        onClick: function onClick() {
          return !item.isRequired && columnClick(item, headersClone, setHeadersClone);
        }
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        className: "column-selector-check",
        dataElementLocation: _taggingHelper.DataElementLocations.BODY,
        dataElementLabel: "checkbox",
        dataElementId: 'column-selector-check-' + tag,
        color: "primary",
        checked: !item.hideColumn,
        disabled: item.isRequired
      }), /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], null, item.title)));
    }
  });
  var firstColumns = [];
  var secondColumns = [];
  Array.isArray(columns) && columns.forEach(function (column, index) {
    var shouldBeInFirstColumn = index < columns.length / 2;
    shouldBeInFirstColumn ? firstColumns.push(column) : secondColumns.push(column);
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "first-column"
  }, firstColumns.map(function (Column) {
    return Column;
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "second-column"
  }, secondColumns.map(function (Column) {
    return Column;
  })));
}